import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  style = {},
  fill = "var(--tlx-surface-bg-surface)",
  width = 16,
  height = 16,
  className = "",
  viewBox,
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox || `0 0 ${width} ${height}`}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M8 7H15C15.2652 7 15.5196 6.89464 15.7071 6.70711C15.8946 6.51957 16 6.26522 16 6V2C16 1.73478 15.8946 1.48043 15.7071 1.29289C15.5196 1.10536 15.2652 1 15 1H11.5L10.5 0H8C7.73478 0 7.48043 0.105357 7.29289 0.292893C7.10536 0.48043 7 0.734784 7 1V3H1V0.25C1 0.183696 0.973661 0.120107 0.926777 0.0732233C0.879893 0.0263392 0.816304 0 0.75 0L0.25 0C0.183696 0 0.120107 0.0263392 0.0732234 0.0732233C0.0263393 0.120107 0 0.183696 0 0.25V12.5C0 12.6326 0.0526784 12.7598 0.146447 12.8536C0.240215 12.9473 0.367392 13 0.5 13H7V15C7 15.2652 7.10536 15.5196 7.29289 15.7071C7.48043 15.8946 7.73478 16 8 16H15C15.2652 16 15.5196 15.8946 15.7071 15.7071C15.8946 15.5196 16 15.2652 16 15V11C16 10.7348 15.8946 10.4804 15.7071 10.2929C15.5196 10.1054 15.2652 10 15 10H11.5L10.5 9H8C7.73478 9 7.48043 9.10536 7.29289 9.29289C7.10536 9.48043 7 9.73478 7 10V12H1V4H7V6C7 6.26522 7.10536 6.51957 7.29289 6.70711C7.48043 6.89464 7.73478 7 8 7ZM8 10H10.0856L11.0856 11H15V15H8V10ZM8 1H10.0856L11.0856 2H15V6H8V1Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
